import type { HTTPService } from "@soft-db/http";
import type { UserScope } from "./user-api";

export type PublicPage = {
	id: string;
	name: string;
	preferredLang: string;
	uniqueToken: string;
	avatarUrl: string | null;
	scope: UserScope;
};

export type CreatePublicPage = {
	name: string;
	preferredLang: string;
};

export type UpdatePublicPage = Partial<CreatePublicPage>;

export class PublicPageApi {
	#http: HTTPService;

	constructor(http: HTTPService) {
		this.#http = http;
	}

	async fetchDistPages(dist: string) {
		return await this.#http.get<PublicPage[]>(`distributors/${dist}/public-pages`);
	}

	async fetchSpacePages(space: string) {
		return await this.#http.get<PublicPage[]>(`spaces/${space}/public-pages`);
	}

	async fetch(id: string) {
		return await this.#http.get<PublicPage>(`public-pages/${id}`);
	}

	async createInDist(dist: string, page: CreatePublicPage) {
		return await this.#http.post<PublicPage>(`distributors/${dist}/public-pages`, page);
	}

	async createInSpace(space: string, page: CreatePublicPage) {
		return await this.#http.post<PublicPage>(`spaces/${space}/public-pages`, page);
	}

	async update(id: string, page: UpdatePublicPage) {
		return await this.#http.patch<PublicPage>(`public-pages/${id}`, page);
	}

	async addSite(id: string, site: string) {
		return await this.#http.post<void>(`public-pages/${id}/sites/${site}`);
	}

	async removeSite(id: string, site: string) {
		return await this.#http.delete<void>(`public-pages/${id}/sites/${site}`);
	}

	async updateAvatar(id: string, file: File) {
		return await this.#http.postFile<PublicPage>(`public-pages/${id}/avatar`, "file", file);
	}

	async deleteAvatar(id: string) {
		return await this.#http.delete<PublicPage>(`public-pages/${id}/avatar`);
	}

	async delete(id: string) {
		return await this.#http.delete(`public-pages/${id}`);
	}
}
